import { Tooltip } from '@nerdwallet/currency';
import Accordion from '@nerdwallet/react-accordion';
import { TooltipIcon } from '~/app/lib/assets/tooltip-icon';
import { useRef } from 'react';
import { useIsHydrated } from '~/app/lib/use-is-hydrated';
import classNames from 'classnames';
import {
  DynamicTextComponent,
  DynamicTextComponentProps,
  DynamicTextForm,
} from '../dynamic-text/dynamic-text-component';

import styles from './dynamic-tooltip.module.scss';

export const DynamicTooltip = ({
  labelProps,
  contentProps,
}: {
  labelProps: DynamicTextComponentProps;
  contentProps: DynamicTextComponentProps;
}) => {
  const hasTextToShowRef = useRef<string>('');
  const isHydrated = useIsHydrated();

  // If not label for the tooltip, return null
  if (!labelProps?.text?.length) {
    return <TooltipIcon />;
  }

  if (!isHydrated) {
    return <DynamicTextComponent {...labelProps} />;
  }

  return (
    <div
      className={classNames(styles.tooltipWrapper, {
        [styles.hideTooltipTrigger]: !hasTextToShowRef.current,
      })}
    >
      <Tooltip
        style={{ minWidth: '12rem' }}
        label={<DynamicTextComponent {...labelProps} />}
        content={
          <DynamicTextComponent
            {...contentProps}
            textToShowCb={(textToShow: string) => {
              hasTextToShowRef.current = textToShow;
            }}
          />
        }
      />
    </div>
  );
};

export const DynamicTooltipForm = () => {
  return (
    <div className={styles.accordionWrapper}>
      <Accordion
        items={[
          {
            id: 'label',
            title: 'Label',
            children: <DynamicTextForm fieldPath="label" />,
          },
          {
            id: 'content',
            title: 'Content',
            children: <DynamicTextForm fieldPath="content" />,
          },
        ]}
      />
    </div>
  );
};
